.settingsPage {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 960px;
  padding: 32px 20px 120px;
}

.pageTitle {
  margin: 0;
}

.card {
  background: var(--ds-off-white);
  border: 1px solid var(--ds-pearl-grey);
  border-radius: 16px;
  padding: 24px 28px;
  box-shadow: 0 1px 2px rgba(31, 31, 48, 0.04);
}

.cardHeading {
  display: block;
  margin-bottom: 16px;
}

.cardGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  align-items: flex-start;
}

@media (--mobile-landscape-and-thinner) {
  .cardGrid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.preferencesWrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* --- Account section --- */

/* Email/username on the left, the two-field password change on the right. */
.accountPanes {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 48px;
  align-items: flex-start;
}

/* The dividing rule is centered in the gap (not on a pane edge) so it lines up with the split
   between the Game and Beta cards below — both this row and that one are the same width and
   centered, so their midlines coincide. */
.accountPanes::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(50% - 0.5px);
  width: 1px;
  background: var(--ds-pearl-grey-dark);
}

@media (--mobile-landscape-and-thinner) {
  .accountPanes {
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
  }

  .accountPanes::after {
    display: none;
  }

  .accountPaneRight {
    border-top: 1px solid var(--ds-pearl-grey-dark);
    padding-top: 24px;
  }
}

.accountRow {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  padding: 16px 0;
  border-top: 1px solid var(--ds-pearl-grey);
}

.accountRow:first-of-type {
  border-top: none;
  padding-top: 4px;
}

.accountInputs {
  flex-grow: 1;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.accountButton {
  flex-shrink: 0;
}

.accountSuccess {
  margin-top: 8px;
}

/* --- Game card --- */

.fieldLabel {
  display: block;
  margin-bottom: 10px;
}

.radioList {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
}

.radioChoice {
  height: 48px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 12px 20px;
  border-radius: 12px;
  cursor: pointer;

  border: 1px solid var(--ds-pearl-grey);

  min-width: 120px;

  &:hover {
    background-color: var(--ds-highlight);
    border-color: transparent;
  }

  &.selectedRadioChoice:not(:hover) {
    background-color: var(--ds-pearl-grey);
  }
}

.radioLabel {
  margin-left: 16px;
}

.radioToggle {
  width: 16px;
  height: 16px;
  background-size: 16px 16px;

  &.fadedToggle {
    opacity: 0.64;
  }
}

.skinPreviews {
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  margin-top: 16px;
}

.cardPreview {
  width: 72px;
  box-shadow:
    0 22px 25px 0 var(--shadow-white),
    0 9px 23px 0 var(--shadow-white);
}

/* --- Beta card --- */

.toggleStack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.betaFeatureInputAndLabel {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  & input {
    margin-right: 12px;
  }
}

/* --- Notifications card --- */

.notificationsTable {
  width: 100%;
  max-width: 560px;

  & tr {
    vertical-align: baseline;
  }

  & tbody tr:nth-child(2n) {
    background: var(--ds-off-white-dark);
  }
}

.notifTableLabel {
  padding: 8px 12px;
}

.notifTableToggle {
  text-align: center;
}

.subsettingWrapper {
  justify-content: center;
}
